// The home page FAQ structured data in public/index.html is in every page's head. A page with its own FAQPage
// hides it, because a page should have only one FAQPage. Returns a function that puts it back.
export function hideSiteFaq() {
  const site = [...document.querySelectorAll('script[type="application/ld+json"]')].find((el) => {
    try { return (JSON.parse(el.textContent)['@graph'] || []).some((item) => item['@type'] === 'FAQPage'); } catch { return false; }
  });
  if (!site) return () => {};
  const original = site.textContent;
  const json = JSON.parse(original);
  json['@graph'] = json['@graph'].filter((item) => item['@type'] !== 'FAQPage');
  site.textContent = JSON.stringify(json);
  return () => { site.textContent = original; };
}
